import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StoreProvider } from '@app/providers';
import { UserServices } from '@app/services';
import { AbstractResetComponent } from '..';

@Component({
    standalone: false,
    selector: 'app-confirm-reset',
    templateUrl: './confirm-reset.component.html',
    styleUrls: ['./confirm-reset.component.scss'],
})
export class ConfirmResetComponent extends AbstractResetComponent {
    constructor(
        router: Router,
        store: StoreProvider,
        userServices: UserServices
    ) {
        super(store, router, userServices);
    }
}
